import React from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from 'components/shared/sidebar/component';
import { SIDEBAR_MODE_PLAYER } from 'components/constants';
import NewTransaction from 'components/shared/transaction/new/component';
export default function ViewNewBankTransaction() {
    var _a = useParams(), type = _a.type, accountId = _a.accountId;
    return (React.createElement("div", null,
        React.createElement(Sidebar, { type: SIDEBAR_MODE_PLAYER }),
        React.createElement("div", { className: "topheader text-align-right" },
            React.createElement(NewTransaction, { type: type, accountId: accountId }))));
}
